import React from 'react';
import Icon from '@components/atoms/icon/icon';
import Button from '@components/atoms/button/button';
import { useTranslation } from 'next-i18next';
import { useContextSelector } from 'use-context-selector';
import { CatalogMaterialHotfilterContext } from '@context/catalog-material-hotfilter.context';
import styles from './material-hotfilter-header.module.scss';

const MaterialHotfilterHeader: React.FC = () => {
  const { t } = useTranslation();
  const { t: tA11y } = useTranslation('a11y');
  const parentLevel = useContextSelector(CatalogMaterialHotfilterContext, (context) => context.parentLevel);
  const menuState = useContextSelector(CatalogMaterialHotfilterContext, (context) => context.menuState);
  const setMenuState = useContextSelector(CatalogMaterialHotfilterContext, (context) => context.setMenuState);

  const handleBackClick = () => {
    if (parentLevel) {
      setMenuState((prev) => ({
        ...prev,
        activeLevel: parentLevel,
        [menuState.activeLevel]: null,
      }));
    }
  };

  const title = menuState[parentLevel]?.name ?? t('CATALOG.FILTERS.MATERIALS');

  return (
    <div className={styles.materialHotfilterHeader}>
      {menuState.activeLevel !== menuState.firstLevel && (
        <Button
          disableDefaultStyling
          onClick={handleBackClick}
          className={styles.materialHotfilterHeader__backButton}
          aria-label={tA11y('A11Y.ICON.BACK')}
        >
          <Icon
            name="arrow-right-long-20"
            ariaHidden
          />
        </Button>
      )}
      <h3 className={styles.materialHotfilterHeader__title}>{title}</h3>
    </div>
  );
};

export default MaterialHotfilterHeader;
